import { Framework } from '@/framework/instance';
import { DEFAULT_STAGE_PADDING, RULER_BAR_EVENTS, RULER_BAR_SIZE } from '@/version-types';
import { setShowRulerBar } from './operations/set-show-ruler-bar';
import { getRulerState } from './states/ruler-state';

export class RulerBar extends Framework {
    /** 显示标尺 */
    showRulerBar() {
        setShowRulerBar(this.identity, true);
    }

    /** 隐藏标尺 */
    hideRulerBar() {
        setShowRulerBar(this.identity, false);
    }

    getShowRulerBar() {
        return getRulerState(this.identity).showRulerBar;
    }

    onShowRulerBarChanged(callback: (show: boolean) => void) {
        const handler = this.framework.events.on(RULER_BAR_EVENTS.ON_SHOW_CHANGED, callback);
        return () => this.framework.events.off(handler);
    }

    emitShowRulerBarChanged(show: boolean) {
        this.framework.events.emit(RULER_BAR_EVENTS.ON_SHOW_CHANGED, show);
    }

    destroy() {
        let padding = this.framework.getConfig().padding || DEFAULT_STAGE_PADDING;
        const showRulerBar = this.getShowRulerBar();
        // 显示标尺的时候, 需要加上标尺的尺寸, 否则会挡住舞台顶部的页面快捷操作
        if (showRulerBar) {
            padding += RULER_BAR_SIZE;
        }
        this.framework.stage.setViewPortPadding(padding);
    }
}
